export default __webpack_public_path__ + "static/media/Scheduling_Filled_Active.90528f7d.svg";